import React from 'react'
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from './header/Header'
import Home from './pages/Home'
import Menu from "./pages/Menu";
import Gallery from "./pages/Gallery";
import Reservation from "./pages/Reservation";
import Contact from "./pages/Contact";
import Pizza from "./pages/Pizza";
import Salads from "./pages/Salads";
import Soups from "./pages/Soups";
import Desserts from "./pages/Desserts";
import Drinks from "./pages/Drinks";
import Signup from "./pages/Signup";
import Cart from "./pages/Cart";
import Special from "./pages/Special";





const Pages = () => {



  return (
    <>
     <BrowserRouter>
      <Header />   
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/boxed" element={<Menu />}></Route>
          <Route path="/gallery" element={<Gallery />}></Route>
          <Route path="/reservation" element={<Reservation />}></Route>
          <Route path="/contactUs" element={<Contact/>}></Route>
          <Route path="/pizza" element={<Pizza />}></Route>
          <Route path="/salads" element={<Salads />}></Route>
          <Route path="/soups" element={<Soups />}></Route>
          <Route path="/desserts" element={<Desserts />}></Route>
          <Route path="/drinks" element={<Drinks />}></Route>
          <Route path="/signup" element={<Signup />}></Route>
          <Route path="/cart" element={<Cart />}></Route>
          <Route path="/special" element={<Special />}></Route>
        </Routes>
      </BrowserRouter>
      
    </>
  )
}

export default Pages
